
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'all');
    setIsVisible(false);
  };

  const handleAcceptNecessary = () => {
    localStorage.setItem('cookieConsent', 'necessary');
    setIsVisible(false);
  };

  const handleSettings = () => {
    navigate('/rechtliches#datenschutz');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Cookie-Einstellungen
            </h3>
            <p className="text-sm text-gray-600 mb-3">
              Wir verwenden Cookies, um Ihnen die bestmögliche Nutzererfahrung zu bieten. 
              Notwendige Cookies sind für die Grundfunktionen der Website erforderlich. 
              Weitere Informationen finden Sie in unserer{' '}
              <button
                onClick={handleSettings}
                className="text-gray-700 hover:text-gray-900 underline cursor-pointer"
              >
                Datenschutzerklärung
              </button>
              .
            </p>
            <div className="text-xs text-gray-500">
              <strong>Notwendige Cookies:</strong> Warenkorb, Sitzungsverwaltung, Sicherheit<br />
              <strong>Funktionale Cookies:</strong> Spracheinstellungen, Präferenzen<br />
              <strong>Keine Tracking-Cookies:</strong> Wir verwenden keine Analyse- oder Marketing-Cookies
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 lg:ml-6">
            <button
              onClick={handleSettings}
              className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-settings-3-line mr-2"></i>
              Einstellungen
            </button>
            <button
              onClick={handleAcceptNecessary}
              className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Nur Notwendige
            </button>
            <button
              onClick={handleAcceptAll}
              className="px-6 py-2 text-sm bg-gray-800 text-white rounded-md hover:bg-gray-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-check-line mr-2"></i>
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
